//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  TITLE_COLOR_GK,
  WHATS_APP_COLOR,
} from "../../utils/colors";

//IMPORT NUMBERS
import {
  WHATS_APP_LINK,
  WHATS_APP_COMERCIAL_LINK,
} from "../../utils/phoneNumbers";
import PolicyModal from "../PolicyModal";
import WhatsAppButton from "../WhatsAppButton";
import "./MainModal.css";

export default function MainModal() {
  return (
    <div className="main-modal-container">
      <div className="main-modal-content-whatsapp">
        <WhatsAppButton
          white={WHITE}
          whatsAppColor={WHATS_APP_COLOR}
          whatsAppNumber={WHATS_APP_LINK}
          whatsAppComercialLink={WHATS_APP_COMERCIAL_LINK}
          btnColor={PRIMARY_BTN_GK}
        />
      </div>

      <PolicyModal
        white={WHITE}
        textColor={TEXT_COLOR}
        btnColor={PRIMARY_BTN_GK}
        titleColor={TITLE_COLOR_GK}
      />
    </div>
  );
}
